// NG 2
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalStorageModule } from 'angular-2-local-storage';
// APP
import { NavmenuComponent } from './components/navmenu/navmenu.component';
import { InfomenuComponent } from './components/navmenu/infomenu.component';
import { LeftmenuComponent } from './components/navmenu/leftmenu.component';
import { TopmenuComponent } from './components/navmenu/topmenu.component';
import{AuthGuardService} from './services/auth-guard.service'; 

import { HomeComponent } from './components/home/home.component';
import { StatenavComponent } from './components/home/statenav.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/login/logout.component';
import { HelpComponent } from './components/home/help.component'; 
import { AccountComponent } from './components/account/account.component';
import { EntityComponent } from './components/entities/entity.component';

import { CreateEntityComponent } from './components/Entities/createentity.component';
import { EditEntityComponent } from './components/Entities/editentity.component';
import { AddContactsComponent } from './components/Entities/addcontacts.component';
import { EditContactComponent } from './components/Entities/editcontact.component';
import { AddSiteEntityComponent } from './components/Entities/addsiteentity.component';
import { EditSiteEntityComponent } from './components/Entities/editsiteentity.component';
import { AddSiteContactsComponent } from './components/Entities/addsitecontacts.component';
import { EditSiteContactComponent } from './components/Entities/editsitecontact.component';
import { ApplicationUploadComponent } from './components/entities/applicationupload.component';
import { ProgressComponent } from './components/common/progress.component';

// Buildings
import { AddbuildingComponent } from './components/buildings/addbuilding.component';

import { AddApplicationComponent } from './components/entities/addapplication.component';
import { HousingAreaComponent } from './components/information/questions/housing-area.component';
import { ConstructionComponent } from './components/information/questions/construction.component';
import { AffordableHousingComponent } from './components/information/questions/affordable-housing.component';

import { UnitCountComponent } from './components/buildings/questions/unitcount.component';
import { PublicFundingComponent } from './components/buildings/questions/publicfunding.component';
import { BuildingTypeComponent } from './components/buildings/questions/buildingtype.component';
import { MIHOptionsComponent } from './components/buildings/questions/mihoptions.component';
import { MIHUnitsComponent } from './components/buildings/questions/mihunits.component';
import { LocationMihSiteUnitComponent } from './components/buildings/questions/locationmihsiteunit.component';

import { TaxCreditComponent } from './components/buildings/questions/taxcredit.component';
import { TaxIncentiveComponent } from './components/buildings/questions/taxincentive.component';
import { SiteUnitCountComponent } from './components/buildings/questions/siteunitcount.component';
import { CondoStructureComponent } from './components/buildings/questions/condostructure.component';
import { ElectricSystemsComponent } from './components/buildings/questions/electricsystems.component';

import { AppModeGuard } from './guards/appmode.guard';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'account', component: AccountComponent, canActivate: [AuthGuardService] },
    { path: 'login', component: LoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'help', component: HelpComponent },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuardService] },
    { path: 'account', component: AccountComponent, canActivate: [AuthGuardService] },
    { path: 'navigator', component: StatenavComponent, canActivate: [AuthGuardService] },

    { path: 'createentity', component: CreateEntityComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'editentity', component: EditEntityComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'entity/application', component: EntityComponent, canActivate: [AuthGuardService] },
    { path: 'entity/addcontacts', component: AddContactsComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'entity/editcontact', component: EditContactComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'entity/addsiteentity', component: AddSiteEntityComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'entity/addsitecontacts', component: AddSiteContactsComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'entity/editsiteentity', component: EditSiteEntityComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'entity/editsitecontact', component: EditSiteContactComponent, canActivate: [AuthGuardService, AppModeGuard] },

    { path: 'entity/addapplication', component: AddApplicationComponent, canActivate: [AuthGuardService] },
    { path: 'information/housingarea', component: HousingAreaComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'information/construction', component: ConstructionComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'information/affordablehousing', component: AffordableHousingComponent, canActivate: [AuthGuardService, AppModeGuard] },

    { path: 'addbuilding', component: AddbuildingComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/unitcount', component: UnitCountComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/publicfunding', component: PublicFundingComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/mihoptions', component: MIHOptionsComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/mihunits', component: MIHUnitsComponent, canActivate: [AuthGuardService, AppModeGuard] },    
    { path: 'buildings/buildingtype', component: BuildingTypeComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/locationmihsiteunit', component: LocationMihSiteUnitComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/taxcredit', component: TaxCreditComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/taxincentive', component: TaxIncentiveComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/siteunitcount', component: SiteUnitCountComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/condostructure', component: CondoStructureComponent, canActivate: [AuthGuardService, AppModeGuard] },
    { path: 'buildings/electricsystems', component: ElectricSystemsComponent, canActivate: [AuthGuardService, AppModeGuard] },

    { path: '**', redirectTo: 'home' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true})
        , LocalStorageModule.withConfig({
            prefix: 'my-app',
            //  storageType: 'localStorage'
            storageType: 'sessionStorage' 
        })
    ],
    exports: [ RouterModule ]
})

export class AppRoutingModule { }
export const routingComponents = [
    LoginComponent, LogoutComponent,
    HelpComponent,
    HomeComponent,
    AccountComponent,
    NavmenuComponent,
    InfomenuComponent,
    LeftmenuComponent,
    TopmenuComponent,
    StatenavComponent,
    ProgressComponent,
    EntityComponent, CreateEntityComponent, EditEntityComponent, AddContactsComponent, EditContactComponent,
    AddSiteEntityComponent, EditSiteEntityComponent, AddSiteContactsComponent, EditSiteContactComponent,
    AddbuildingComponent,  
    AddApplicationComponent,
    HousingAreaComponent, ConstructionComponent, AffordableHousingComponent, 
    UnitCountComponent, PublicFundingComponent, BuildingTypeComponent,
    MIHOptionsComponent, MIHUnitsComponent, LocationMihSiteUnitComponent,
    TaxCreditComponent, TaxIncentiveComponent, SiteUnitCountComponent,
    CondoStructureComponent, ElectricSystemsComponent
]